<template>
  <div>
    <div class="alert alert-info">
      Kolom isian dengan tanda bintang (<span style="color: red">*</span>) adalah wajib untuk di isi. <strong>{{messages}}</strong>
    </div>
    <center>
      <pulse-loader style="margin: 15px" :loading="loading" color="#696969" size="10px"></pulse-loader>
    </center>
    <form class="form-horizontal form-space" onsubmit="return false">
      <div v-show="isExist('NAMA')" :class="{'form-group': true, 'has-error': errors.has('nama_lengkap')}">
        <label class="col-md-3"><span class="required-label">*</span>Nama Lengkap</label>
        <div class="col-md-6">
          <input
            type="text"
            name="nama_lengkap"
            placeholder="Nama Lengkap"
            class="form-control"
            maxlength="100"
            v-model="model.nama_lengkap"
            v-validate="isExist('NAMA') ? 'required' : ''"
          >
          <span v-show="errors.has('nama_lengkap')" class="error-label">Isi Nama Lengkap</span>
        </div>
      </div>
      <div v-show="isExist('GD_A')" class="form-group">
        <label class="col-md-3">Gelar Depan</label>
        <div class="col-md-6">
          <input
            type="text"
            name="gelar_depan"
            placeholder="Gelar Depan"
            class="form-control"
            maxlength="32"
            v-model="model.gelar_depan"
          >
        </div>
      </div>
      <div v-show="isExist('GB_A')" :class="{'form-group': true, 'has-error': errors.has('gelar_belakang')}">
        <label class="col-md-3"><span class="required-label">*</span>Gelar Belakang</label>
        <div class="col-md-6">
          <input
            type="text"
            name="gelar_belakang"
            placeholder="Gelar Belakang"
            class="form-control"
            maxlength="32"
            v-model="model.gelar_belakang"
            v-validate="isExist('GB_A') ? 'required' : ''"
          >
          <span v-show="errors.has('gelar_belakang')" class="error-label">Isi Gelar Belakang</span>
        </div>
      </div>
      <div v-show="isExist('GD_NA')" class="form-group">
        <label class="col-md-3">Gelar Depan Non Akademik</label>
        <div class="col-md-6">
          <input
            type="text"
            name="gelar_depan_na"
            placeholder="Gelar Depan Non Akademik"
            class="form-control"
            maxlength="32"
            v-model="model.gelar_depan_na"
          >
        </div>
      </div>
      <div v-show="isExist('GB_NA')" class="form-group">
        <label class="col-md-3">Gelar Belakang Non Akademik</label>
        <div class="col-md-6">
          <input
            type="text"
            name="gelar_depan_na"
            placeholder="Gelar Belakang Non Akademik"
            class="form-control"
            maxlength="32"
            v-model="model.gelar_belakang_na"
          >
        </div>
      </div>
      <div v-show="isExist('JK')" :class="{'form-group': true, 'has-error': errors.has('jenis_kelamin')}">
        <label class="col-md-3"><span class="required-label">*</span>Jenis Kelamin</label>
        <div class="col-md-4">
          <select
            type="text"
            name="jenis_kelamin"
            class="form-control"
            v-model="model.jenis_kelamin"
            v-validate="isExist('JK') ? 'required' : ''"
          >
            <option value="null" hidden>Pilih Jenis Kelamin</option>
            <option value="L">Laki-Laki</option>
            <option value="P">Perempuan</option>
          </select>
          <span v-show="errors.has('jenis_kelamin')" class="error-label">Pilih Jenis Kelamin</span>
        </div>
      </div>
      <div v-show="isExist('TL')" :class="{'form-group': true, 'has-error': errors.has('tempat_lahir')}">
        <label class="col-md-3"><span class="required-label">*</span>Tempat Lahir</label>
        <div class="col-md-4">
          <select
            type="text"
            name="tempat_lahir"
            class="form-control"
            v-model="model.tempat_lahir"
            v-validate="isExist('TL') ? 'required' : ''"
            v-on:change="() => onChangeProvinsiLahir(true)"
          >
            <option value="null" hidden>Pilih Tempat Lahir</option>
            <option v-for="provinsi in options.provinsi" :key="provinsi.id" :value="provinsi.kode_provinsi">
              {{ provinsi.nama_provinsi }}
            </option>
          </select>
          <span v-show="errors.has('tempat_lahir')" class="error-label">Pilih Tempat Lahir</span>
        </div>
      </div>
      <div v-show="isExist('KAB_LAHIR')" :class="{'form-group': true, 'has-error': errors.has('kabupaten_lahir')}">
        <label class="col-md-3"><span class="required-label">*</span>Kabupaten Lahir</label>
        <div class="col-md-4">
          <select
            type="text"
            name="kabupaten_lahir"
            class="form-control"
            v-model="model.kabupaten_lahir"
            v-validate="isExist('KAB_LAHIR') ? 'required' : ''"
          >
            <option value="null" hidden>Pilih Kabupaten Lahir</option>
            <option v-for="kabupaten in options.kabupatenLahir" :key="kabupaten.id" :value="kabupaten.kode_kabupaten">
              {{ kabupaten.nama_kabupaten }}
            </option>
          </select>
          <span v-show="errors.has('kabupaten_lahir')" class="error-label">Pilih Kabupaten Lahir</span>
          <pulse-loader style="margin: 15px" :loading="loadingKabupatenLahir" color="#696969" size="10px"></pulse-loader>
        </div>
      </div>
      <div v-if="isExist('TGL_LAHIR')" :class="{'form-group': true, 'has-error': errors.has('tgl_lahir')}">
        <label class="col-md-3"><span class="required-label">*</span>Tanggal Lahir</label>
        <div class="col-md-4">
          <input
            type="date"
            name="tgl_lahir"
            class="form-control"
            v-model="model.tgl_lahir"
            v-validate="isExist('TGL_LAHIR') ? 'required' : ''"
          >
          <span v-show="errors.has('tgl_lahir')" class="error-label">Isi Tanggal Lahir</span>
        </div>
      </div>
      <div v-show="isExist('AGAMA')" :class="{'form-group': true, 'has-error': errors.has('id_agama')}">
        <label class="col-md-3"><span class="required-label">*</span>Agama</label>
        <div class="col-md-4">
          <select
            type="text"
            name="id_agama"
            class="form-control"
            v-model="model.id_agama"
            v-validate="isExist('AGAMA') ? 'required' : ''"
          >
            <option value="null" hidden>Pilih Agama</option>
            <option v-for="agama in options.agama" :key="agama.id" :value="agama.id_agama">
              {{ agama.nama_agama }}
            </option>
          </select>
          <span v-show="errors.has('id_agama')" class="error-label">Pilih Agama</span>
        </div>
      </div>
      <div v-show="isExist('NEGARA')" :class="{'form-group': true, 'has-error': errors.has('warga_negara')}">
        <label class="col-md-3"><span class="required-label">*</span>Warga Negara</label>
        <div class="col-md-4">
          <select
            type="text"
            name="warga_negara"
            class="form-control"
            v-model="model.warga_negara"
            v-validate="isExist('NEGARA') ? 'required' : ''"
          >
            <option value="null" hidden>Pilih Warga Negara</option>
            <option v-for="negara in options.negara" :key="negara.id" :value="negara.kode_negara">
              {{ negara.nama_negara }}
            </option>
          </select>
          <span v-show="errors.has('warga_negara')" class="error-label">Pilih Warga Negara</span>
        </div>
      </div>
      <div v-show="isExist('KTP')" :class="{'form-group': true, 'has-error': errors.has('no_ktp')}">
        <label class="col-md-3"><span class="required-label">*</span>Nomor KTP</label>
        <div class="col-md-6">
          <input
            type="text"
            name="no_ktp"
            placeholder="Nomor KTP"
            class="form-control"
            maxlength="25"
            v-model="model.no_ktp"
            v-validate="isExist('KTP') ? 'required' : ''"
          >
          <span v-show="errors.has('no_ktp')" class="error-label">Isi Nomor KTP</span>
        </div>
      </div>
      <div v-if="isExist('TGL_KTP')" :class="{'form-group': true, 'has-error': errors.has('tanggal_akhir_ktp')}">
        <label class="col-md-3"><span class="required-label">*</span>Tanggal Akhir KTP</label>
        <div class="col-md-4">
          <input
            type="date"
            name="tanggal_akhir_ktp"
            class="form-control"
            v-model="model.tanggal_akhir_ktp"
            v-validate="isExist('TGL_KTP') ? 'required' : ''"
          >
          <span v-show="errors.has('tanggal_akhir_ktp')" class="error-label">Isi Tanggal Akhir KTP</span>
        </div>
      </div>
      <div v-if="isExist('GOL_DARAH')" :class="{'form-group': true, 'has-error': errors.has('gol_darah')}">
        <label class="col-md-3"><span class="required-label">*</span>Golongan Darah</label>
        <div class="col-md-9">
          <input type="radio" id="gol-a" name="gol_darah" v-model="model.gol_darah" value="A"
            v-validate="isExist('GOL_DARAH') ? 'required' : ''" data-vv-validate-on="change">
          <label for="gol-a">A</label>
          <input type="radio" id="gol-b" name="gol_darah" v-model="model.gol_darah" value="B">
          <label for="gol-b">B</label>
          <input type="radio" id="gol-ab" name="gol_darah" v-model="model.gol_darah" value="AB">
          <label for="gol-ab">AB</label>
          <input type="radio" id="gol-o" name="gol_darah" v-model="model.gol_darah" value="O">
          <label for="gol-o">O</label>
          <span v-show="errors.has('gol_darah')" class="error-label">Pilih Golongan Darah</span>
        </div>
      </div>
      <div v-show="isExist('TBDN')" :class="{'form-group': true, 'has-error': errors.has('tinggi_badan')}">
        <label class="col-md-3"><span class="required-label">*</span>Tinggi Badan (cm)</label>
        <div class="col-md-6">
          <input
            type="text"
            name="tinggi_badan"
            placeholder="Tinggi Badan (cm)"
            class="form-control"
            maxlength="5"
            v-model="model.tinggi_badan"
            v-validate="isExist('TBDN') ? 'required' : ''"
          >
          <span v-show="errors.has('tinggi_badan')" class="error-label">Isi Tinggi Badan</span>
        </div>
      </div>
      <div v-show="isExist('BBDN')" :class="{'form-group': true, 'has-error': errors.has('berat_badan')}">
        <label class="col-md-3"><span class="required-label">*</span>Berat Badan (kg)</label>
        <div class="col-md-6">
          <input
            type="text"
            name="berat_badan"
            placeholder="Berat Badan (kg)"
            class="form-control"
            maxlength="5"
            v-model="model.berat_badan"
            v-validate="isExist('BBDN') ? 'required' : ''"
          >
          <span v-show="errors.has('berat_badan')" class="error-label">Isi Berat Badan</span>
        </div>
      </div>
      <div v-show="isExist('NEGARA_ASAL')" :class="{'form-group': true, 'has-error': errors.has('negara_asal')}">
        <label class="col-md-3"><span class="required-label">*</span>Negara di KTP</label>
        <div class="col-md-4">
          <select
            type="text"
            name="negara_asal"
            class="form-control"
            v-model="model.negara_asal"
            v-validate="isExist('NEGARA_ASAL') ? 'required' : ''"
          >
            <option value="null" hidden>Pilih Negara di KTP</option>
            <option v-for="negara in options.negara" :key="negara.id" :value="negara.kode_negara">
              {{ negara.nama_negara }}
            </option>
          </select>
          <span v-show="errors.has('negara_asal')" class="error-label">Pilih Negara di KTP</span>
        </div>
      </div>
      <div v-show="isExist('PROV_ASAL')" :class="{'form-group': true, 'has-error': errors.has('kode_provinsi_asal')}">
        <label class="col-md-3"><span class="required-label">*</span>Provinsi di KTP</label>
        <div class="col-md-4">
          <select
            type="text"
            name="kode_provinsi_asal"
            class="form-control"
            v-model="model.kode_provinsi_asal"
            v-validate="isExist('PROV_ASAL') ? 'required' : ''"
            v-on:change="() => onChangeProvinsiAsal(true)"
          >
            <option value="null" hidden>Pilih Provinsi di KTP</option>
            <option v-for="provinsi in options.provinsi" :key="provinsi.id" :value="provinsi.kode_provinsi">
              {{ provinsi.nama_provinsi }}
            </option>
          </select>
          <span v-show="errors.has('kode_provinsi_asal')" class="error-label">Pilih Provinsi di KTP</span>
        </div>
      </div>
      <div v-show="isExist('KAB_ASAL')" :class="{'form-group': true, 'has-error': errors.has('kode_kabupaten_asal')}">
        <label class="col-md-3"><span class="required-label">*</span>Kabupaten di KTP</label>
        <div class="col-md-4">
          <select
            type="text"
            name="kode_kabupaten_asal"
            class="form-control"
            v-model="model.kode_kabupaten_asal"
            v-validate="isExist('KAB_ASAL') ? 'required' : ''"
            v-on:change="() => onChangeKabupatenAsal(true)"
          >
            <option value="null" hidden>Pilih Kabupaten di KTP</option>
            <option v-for="kabupaten in options.kabupatenAsal" :key="kabupaten.id" :value="kabupaten.kode_kabupaten">
              {{ kabupaten.nama_kabupaten }}
            </option>
          </select>
          <span v-show="errors.has('kode_kabupaten_asal')" class="error-label">Pilih Kabupaten di KTP</span>
          <pulse-loader style="margin: 15px" :loading="loadingKabupatenAsal" color="#696969" size="10px"></pulse-loader>
        </div>
      </div>
      <div v-show="isExist('KEC_ASAL')" :class="{'form-group': true, 'has-error': errors.has('kode_kecamatan_asal')}">
        <label class="col-md-3"><span class="required-label">*</span>Kecamatan di KTP</label>
        <div class="col-md-4">
          <select
            type="text"
            name="kode_kecamatan_asal"
            class="form-control"
            v-model="model.kode_kecamatan_asal"
            v-validate="isExist('KEC_ASAL') ? 'required' : ''"
          >
            <option value="null" hidden>Pilih Kecamatan di KTP</option>
            <option v-for="kecamatan in options.kecamatanAsal" :key="kecamatan.id" :value="kecamatan.kode_kecamatan">
              {{ kecamatan.nama_kecamatan }}
            </option>
          </select>
          <span v-show="errors.has('kode_kecamatan_asal')" class="error-label">Pilih Kecamatan di KTP</span>
          <pulse-loader style="margin: 15px" :loading="loadingKecamatanAsal" color="#696969" size="10px"></pulse-loader>
        </div>
      </div>
      <div v-show="isExist('KELURAHAN_ASAL')" :class="{'form-group': true, 'has-error': errors.has('kelurahan_asal')}">
        <label class="col-md-3"><span class="required-label">*</span>Kelurahan di KTP</label>
        <div class="col-md-6">
          <input
            type="text"
            name="kelurahan_asal"
            placeholder="Kelurahan di KTP"
            class="form-control"
            maxlength="30"
            v-model="model.kelurahan_asal"
            v-validate="isExist('KELURAHAN_ASAL') ? 'required' : ''"
          >
          <span v-show="errors.has('kelurahan_asal')" class="error-label">Isi Kelurahan di KTP</span>
        </div>
      </div>
      <div v-show="isExist('RW_ASAL')" :class="{'form-group': true, 'has-error': errors.has('rw_asal')}">
        <label class="col-md-3"><span class="required-label">*</span>RW di KTP</label>
        <div class="col-md-6">
          <input
            type="number"
            min="0" max="999" step="1" oninput="validity.valid||(value='');"
            name="rw_asal"
            placeholder="RW di KTP"
            class="form-control"
            v-model="model.rw_asal"
            v-validate="isExist('RW_ASAL') ? 'required' : ''"
          >
          <span v-show="errors.has('rw_asal')" class="error-label">Isi RW di KTP</span>
        </div>
      </div>
      <div v-show="isExist('RT_ASAL')" :class="{'form-group': true, 'has-error': errors.has('rt_asal')}">
        <label class="col-md-3"><span class="required-label">*</span>RT di KTP</label>
        <div class="col-md-6">
          <input
            type="number"
            min="0" max="999" step="1" oninput="validity.valid||(value='');"
            name="rt_asal"
            placeholder="RT di KTP"
            class="form-control"
            v-model="model.rt_asal"
            v-validate="isExist('RT_ASAL') ? 'required' : ''"
          >
          <span v-show="errors.has('rt_asal')" class="error-label">Isi RT di KTP</span>
        </div>
      </div>
      <div v-show="isExist('ALAMAT_ASAL')" :class="{'form-group': true, 'has-error': errors.has('alamat_asal')}">
        <label class="col-md-3"><span class="required-label">*</span>Alamat di KTP</label>
        <div class="col-md-6">
          <input
            type="text"
            name="alamat_asal"
            placeholder="Alamat di KTP"
            class="form-control"
            maxlength="255"
            v-model="model.alamat_asal"
            v-validate="isExist('ALAMAT_ASAL') ? 'required' : ''"
          >
          <span v-show="errors.has('alamat_asal')" class="error-label">Isi Alamat di KTP</span>
        </div>
      </div>
      <div v-show="isExist('KD_POS')" :class="{'form-group': true, 'has-error': errors.has('kode_pos_asal')}">
        <label class="col-md-3"><span class="required-label">*</span>Kode Pos di KTP</label>
        <div class="col-md-6">
          <input
            type="text"
            name="kode_pos_asal"
            placeholder="Kode Pos di KTP"
            class="form-control"
            maxlength="30"
            v-model="model.kode_pos_asal"
            v-validate="isExist('KD_POS') ? 'required' : ''"
          >
          <span v-show="errors.has('kode_pos_asal')" class="error-label">Isi Kode Pos di KTP</span>
        </div>
      </div>
      <!--div>
        <label class="col-md-3"> Apakah Alamat KTP Sama Dengan Saat Ini?</label>
        <div class="col-md-4">
          <input style="padding: 100px"
            type="checkbox"
            name="ktp_sama"
          >Ya
        </div>
      </div-->
      <input type="checkbox" id="checkbox" v-model="checkboxKTP" v-on:change="onChangeCheckBox">
      <label style="margin-left: 5px; margin-bottom: 25px" for="checkbox">Alamat di KTP sama dengan alamat saat ini</label>
      <div v-show="isExist('PROV_INI') && !checkboxKTP" :class="{'form-group': true, 'has-error': errors.has('kode_provinsi')}">
        <label class="col-md-3"><span class="required-label">*</span>Provinsi Saat Ini</label>
        <div class="col-md-4">
          <select
            type="text"
            name="kode_provinsi"
            class="form-control"
            v-model="model.kode_provinsi"
            v-validate="isExist('PROV_INI') ? 'required' : ''"
            v-on:change="() => onChangeProvinsiSaatIni(true)"
          >
            <option value="null" hidden>Pilih Provinsi Saat Ini</option>
            <option v-for="provinsi in options.provinsi" :key="provinsi.id" :value="provinsi.kode_provinsi">
              {{ provinsi.nama_provinsi }}
            </option>
          </select>
          <span v-show="errors.has('kode_provinsi')" class="error-label">Pilih Provinsi Saat Ini</span>
        </div>
      </div>
      <div v-show="isExist('KAB_INI') && !checkboxKTP" :class="{'form-group': true, 'has-error': errors.has('kode_kabupaten')}">
        <label class="col-md-3"><span class="required-label">*</span>Kabupaten Saat Ini</label>
        <div class="col-md-4">
          <select
            type="text"
            name="kode_kabupaten"
            class="form-control"
            v-model="model.kode_kabupaten"
            v-validate="isExist('KAB_INI') ? 'required' : ''"
            v-on:change="() => onChangeKabupatenIni(true)"
          >
            <option value="null" hidden>Pilih Kabupaten Saat Ini</option>
            <option v-for="kabupaten in options.kabupatenSaatIni" :key="kabupaten.id" :value="kabupaten.kode_kabupaten">
              {{ kabupaten.nama_kabupaten }}
            </option>
          </select>
          <span v-show="errors.has('kode_kabupaten')" class="error-label">Pilih Kabupaten Saat Ini</span>
          <pulse-loader style="margin: 15px" :loading="loadingKabupatenIni" color="#696969" size="10px"></pulse-loader>
        </div>
      </div>
      <div v-show="isExist('KEC_INI') && !checkboxKTP" :class="{'form-group': true, 'has-error': errors.has('kode_kecamatan')}">
        <label class="col-md-3"><span class="required-label">*</span>Kecamatan Saat Ini</label>
        <div class="col-md-4">
          <select
            type="text"
            name="kode_kecamatan"
            class="form-control"
            v-model="model.kode_kecamatan"
            v-validate="isExist('KEC_INI') ? 'required' : ''"
          >
            <option value="null" hidden>Pilih Kecamatan Saat Ini</option>
            <option v-for="kecamatan in options.kecamatanSaatIni" :key="kecamatan.id" :value="kecamatan.kode_kecamatan">
              {{ kecamatan.nama_kecamatan }}
            </option>
          </select>
          <span v-show="errors.has('kode_kecamatan')" class="error-label">Pilih Kecamatan Saat Ini</span>
          <pulse-loader style="margin: 15px" :loading="loadingKecamatanIni" color="#696969" size="10px"></pulse-loader>
        </div>
      </div>
      <div>
      <div v-show="isExist('DESA_INI') && !checkboxKTP" :class="{'form-group': true, 'has-error': errors.has('kelurahan')}">
        <label class="col-md-3"><span class="required-label">*</span>Kelurahan Saat Ini</label>
        <div class="col-md-6">
          <input
            type="text"
            name="kelurahan"
            placeholder="Kelurahan Saat Ini"
            class="form-control"
            maxlength="30"
            v-model="model.kelurahan"
            v-validate="isExist('DESA_INI') ? 'required' : ''"
          >
          <span v-show="errors.has('kelurahan')" class="error-label">Isi Kelurahan Saat Ini</span>
        </div>
      </div>
      </div>
      <div v-show="isExist('RW_INI') && !checkboxKTP" :class="{'form-group': true, 'has-error': errors.has('rw')}">
        <label class="col-md-3"><span class="required-label">*</span>RW Saat Ini</label>
        <div class="col-md-6">
          <input
            type="text"
            name="rw"
            placeholder="RW Saat Ini"
            class="form-control"
            maxlength="25"
            v-model="model.rw"
            v-validate="isExist('RW_INI') ? 'required' : ''"
          >
          <span v-show="errors.has('rw')" class="error-label">Isi RW Saat Ini</span>
        </div>
      </div>
      <div v-show="isExist('RT_INI') && !checkboxKTP" :class="{'form-group': true, 'has-error': errors.has('rt')}">
        <label class="col-md-3"><span class="required-label">*</span>RT Saat Ini</label>
        <div class="col-md-6">
          <input
            type="text"
            name="rt"
            placeholder="RT Saat Ini"
            class="form-control"
            maxlength="25"
            v-model="model.rt"
            v-validate="isExist('RT_INI') ? 'required' : ''"
          >
          <span v-show="errors.has('rt')" class="error-label">Isi RT Saat Ini</span>
        </div>
      </div>
      <div v-show="isExist('ALAMAT_INI') && !checkboxKTP" :class="{'form-group': true, 'has-error': errors.has('alamat_lengkap')}">
        <label class="col-md-3"><span class="required-label">*</span>Alamat Saat Ini</label>
        <div class="col-md-6">
          <input
            type="text"
            name="alamat_lengkap"
            placeholder="Alamat Saat Ini"
            class="form-control"
            maxlength="255"
            v-model="model.alamat_lengkap"
            v-validate="isExist('ALAMAT_INI') ? 'required' : ''"
          >
          <span v-show="errors.has('alamat_lengkap')" class="error-label">Isi Alamat Saat Ini</span>
        </div>
      </div>
      <div v-show="isExist('KD_POS_INI') && !checkboxKTP" :class="{'form-group': true, 'has-error': errors.has('kode_pos')}">
        <label class="col-md-3"><span class="required-label">*</span>Kode Pos Saat Ini</label>
        <div class="col-md-6">
          <input
            type="text"
            name="kode_pos"
            placeholder="Kode Pos Saat Ini"
            class="form-control"
            maxlength="12"
            v-model="model.kode_pos"
            v-validate="isExist('KD_POS_INI') ? 'required' : ''"
          >
          <span v-show="errors.has('kode_pos')" class="error-label">Isi Kode Pos Saat Ini</span>
        </div>
      </div>
      <div v-show="isExist('TELP')" :class="{'form-group': true, 'has-error': errors.has('telp')}">
        <label class="col-md-3"><span class="required-label">*</span>Nomor HP</label>
        <div class="col-md-6">
          <input
            type="text"
            name="telp"
            placeholder="Nomor HP"
            class="form-control"
            maxlength="20"
            v-model="model.telp"
            v-validate="isExist('TELP') ? 'required' : ''"
          >
          <span v-show="errors.has('telp')" class="error-label">Isi Nomor HP</span>
        </div>
      </div>
      <div v-show="isExist('HP')" :class="{'form-group': true, 'has-error': errors.has('nohp')}">
        <label class="col-md-3"><span class="required-label">*</span>Nomor WhatsApp</label>
        <div class="col-md-6">
          <input
            type="text"
            name="nohp"
            placeholder="Nomor WhatsApp"
            class="form-control"
            maxlength="15"
            v-model="model.nohp"
            v-validate="isExist('HP') ? 'required' : ''"
          >
          <span v-show="errors.has('nohp')" class="error-label">Isi Nomor Whatsapp</span>
        </div>
      </div>
      <div v-show="isExist('EMAIL')" :class="{'form-group': true, 'has-error': errors.has('email')}">
        <label class="col-md-3"><span class="required-label">*</span>Email</label>
        <div class="col-md-6">
          <input
            type="text"
            name="email"
            placeholder="Email"
            class="form-control"
            maxlength="150"
            v-model="model.email"
            v-validate="isExist('EMAIL') ? 'required|email' : 'email'"
          >
          <span v-show="errors.has('email')" class="error-label">Isi Email dan Dengan Format Yang Benar</span>
        </div>
      </div>
      <div v-show="isExist('WEBSITE')" class="form-group">
        <label class="col-md-3">Website</label>
        <div class="col-md-6">
          <input
            type="text"
            name="website"
            placeholder="Website"
            class="form-control"
            maxlength="150"
            v-model="model.website"
          >
        </div>
      </div>
      <div v-show="isExist('BLOG')" class="form-group">
        <label class="col-md-3">Blog</label>
        <div class="col-md-6">
          <input
            type="text"
            name="blog"
            placeholder="Blog"
            class="form-control"
            maxlength="125"
            v-model="model.blog"
          >
        </div>
      </div>
      <div v-show="isExist('TWIT')" class="form-group">
        <label class="col-md-3">Twitter</label>
        <div class="col-md-6">
          <input
            type="text"
            name="twitter"
            placeholder="Twitter"
            class="form-control"
            maxlength="125"
            v-model="model.twitter"
          >
        </div>
      </div>
      <div v-show="isExist('FB')" class="form-group">
        <label class="col-md-3">Facebook</label>
        <div class="col-md-6">
          <input
            type="text"
            name="facebook"
            placeholder="Facebook"
            class="form-control"
            maxlength="150"
            v-model="model.facebook"
          >
        </div>
      </div>
      <div v-show="isExist('NAMA_PKJ')" :class="{'form-group': true, 'has-error': errors.has('nama_pekerjaan')}">
        <label class="col-md-3"><span class="required-label">*</span>Nama Pekerjaan</label>
        <div class="col-md-6">
          <input
            type="text"
            name="nama_pekerjaan"
            placeholder="Nama Pekerjaan"
            class="form-control"
            maxlength="150"
            v-model="modelPkj.nama_pekerjaan"
            v-validate="isExist('NAMA_PKJ') ? 'required' : ''"
          >
          <span v-show="errors.has('nama_pekerjaan')" class="error-label">Isi Nama Pekerjaan</span>
        </div>
      </div>
      <div v-show="isExist('PROV_PKJ')" :class="{'form-group': true, 'has-error': errors.has('kode_provinsi_pkj')}">
        <label class="col-md-3"><span class="required-label">*</span>Provinsi Pekerjaan</label>
        <div class="col-md-4">
          <select
            type="text"
            name="kode_provinsi_pkj"
            class="form-control"
            v-model="modelPkj.kode_provinsi"
            v-validate="isExist('PROV_PKJ') ? 'required' : ''"
            v-on:change="onChangeProvinsiPkj"
          >
            <option value="null" hidden>Pilih Provinsi Pekerjaan</option>
            <option v-for="provinsi in options.provinsi" :key="provinsi.id" :value="provinsi.kode_provinsi">
              {{ provinsi.nama_provinsi }}
            </option>
          </select>
          <span v-show="errors.has('kode_provinsi_pkj')" class="error-label">Pilih Provinsi Pekerjaan</span>
        </div>
      </div>
      <div v-show="isExist('KAB_PKJ')" :class="{'form-group': true, 'has-error': errors.has('kode_kabupaten_pkj')}">
        <label class="col-md-3"><span class="required-label">*</span>Kabupaten Pekerjaan</label>
        <div class="col-md-4">
          <select
            type="text"
            name="kode_kabupaten_pkj"
            class="form-control"
            v-model="modelPkj.kode_kabupaten"
            v-validate="isExist('KAB_PKJ') ? 'required' : ''"
            v-on:change="onChangeKabupatenPkj"
          >
            <option value="null" hidden>Pilih Kabupaten Pekerjaan</option>
            <option v-for="kabupaten in options.kabupatenPkj" :key="kabupaten.id" :value="kabupaten.kode_kabupaten">
              {{ kabupaten.nama_kabupaten }}
            </option>
          </select>
          <span v-show="errors.has('kode_kabupaten_pkj')" class="error-label">Pilih Kabupaten Pekerjaan</span>
          <pulse-loader style="margin: 15px" :loading="loadingKabupatenPkj" color="#696969" size="10px"></pulse-loader>
        </div>
      </div>
      <div v-show="isExist('KEC_PKJ')" :class="{'form-group': true, 'has-error': errors.has('kode_kecamatan_pkj')}">
        <label class="col-md-3"><span class="required-label">*</span>Kecamatan Pekerjaan</label>
        <div class="col-md-4">
          <select
            type="text"
            name="kode_kecamatan_pkj"
            class="form-control"
            v-model="modelPkj.kode_kecamatan"
            v-validate="isExist('KEC_PKJ') ? 'required' : ''"
          >
            <option value="null" hidden>Pilih Kecamatan Pekerjaan</option>
            <option v-for="kecamatan in options.kecamatanPkj" :key="kecamatan.id" :value="kecamatan.kode_kecamatan">
              {{ kecamatan.nama_kecamatan }}
            </option>
          </select>
          <span v-show="errors.has('kode_kecamatan_pkj')" class="error-label">Pilih Kecamatan Pekerjaan</span>
          <pulse-loader style="margin: 15px" :loading="loadingKecamatanPkj" color="#696969" size="10px"></pulse-loader>
        </div>
      </div>
      <div v-show="isExist('DESA_PKJ')" :class="{'form-group': true, 'has-error': errors.has('kode_kelurahan_pkj')}">
        <label class="col-md-3"><span class="required-label">*</span>Kelurahan Pekerjaan</label>
        <div class="col-md-6">
          <input
            type="text"
            name="kode_kelurahan_pkj"
            placeholder="Kelurahan Pekerjaan"
            class="form-control"
            maxlength="50"
            v-model="modelPkj.kode_kelurahan"
            v-validate="isExist('DESA_PKJ') ? 'required' : ''"
          >
          <span v-show="errors.has('kode_kelurahan_pkj')" class="error-label">Isi Kelurahan Pekerjaan</span>
        </div>
      </div>
      <div v-show="isExist('RW_PKJ')" :class="{'form-group': true, 'has-error': errors.has('rw_pkj')}">
        <label class="col-md-3"><span class="required-label">*</span>RW Pekerjaan</label>
        <div class="col-md-6">
          <input
            type="text"
            name="rw_pkj"
            placeholder="RW Pekerjaan"
            class="form-control"
            maxlength="3"
            v-model="modelPkj.rw"
            v-validate="isExist('RW_PKJ') ? 'required' : ''"
          >
          <span v-show="errors.has('kode_kelurahan_pkj')" class="error-label">Isi RW Pekerjaan</span>
        </div>
      </div>
      <div v-show="isExist('RT_PKJ')" :class="{'form-group': true, 'has-error': errors.has('rt_pkj')}">
        <label class="col-md-3"><span class="required-label">*</span>RT Pekerjaan</label>
        <div class="col-md-6">
          <input
            type="text"
            name="rt_pkj"
            placeholder="RT Pekerjaan"
            class="form-control"
            maxlength="3"
            v-model="modelPkj.rt"
            v-validate="isExist('RT_PKJ') ? 'required' : ''"
          >
          <span v-show="errors.has('rt_pkj')" class="error-label">Isi RT Pekerjaan</span>
        </div>
      </div>
      <div v-show="isExist('ALAMAT_PKJ')" :class="{'form-group': true, 'has-error': errors.has('alamat_pkj')}">
        <label class="col-md-3"><span class="required-label">*</span>Alamat Pekerjaan</label>
        <div class="col-md-6">
          <input
            type="text"
            name="alamat_pkj"
            placeholder="Alamat Pekerjaan"
            class="form-control"
            maxlength="50"
            v-model="modelPkj.alamat"
            v-validate="isExist('ALAMAT_PKJ') ? 'required' : ''"
          >
          <span v-show="errors.has('alamat_pkj')" class="error-label">Isi Alamat Pekerjaan</span>
        </div>
      </div>
      <div v-show="isExist('KD_POS_PKJ')" :class="{'form-group': true, 'has-error': errors.has('kode_pos_pkj')}">
        <label class="col-md-3"><span class="required-label">*</span>Kode Pos Pekerjaan</label>
        <div class="col-md-6">
          <input
            type="text"
            name="kode_pos_pkj"
            placeholder="Kode Pos Pekerjaan"
            class="form-control"
            maxlength="10"
            v-model="modelPkj.kode_pos"
            v-validate="isExist('KD_POS_PKJ') ? 'required' : ''"
          >
          <span v-show="errors.has('kode_pos_pkj')" class="error-label">Isi Kode Pos Pekerjaan</span>
        </div>
      </div>
      <div v-show="isExist('TELP_PKJ')" :class="{'form-group': true, 'has-error': errors.has('telp_pkj')}">
        <label class="col-md-3"><span class="required-label">*</span>Telepon Pekerjaan</label>
        <div class="col-md-6">
          <input
            type="text"
            name="telp_pkj"
            placeholder="Telepon Pekerjaan"
            class="form-control"
            maxlength="15"
            v-model="modelPkj.telp"
            v-validate="isExist('TELP_PKJ') ? 'required' : ''"
          >
          <span v-show="errors.has('telp_pkj')" class="error-label">Isi Telepon Pekerjaan</span>
        </div>
      </div>
      <div v-show="isExist('FAX_PKJ')" class="form-group">
        <label class="col-md-3">Fax Pekerjaan</label>
        <div class="col-md-6">
          <input
            type="text"
            name="fax_pkj"
            placeholder="Fax Pekerjaan"
            class="form-control"
            maxlength="20"
            v-model="modelPkj.fax"
          >
        </div>
      </div>
      <div v-show="isExist('EMAIL_PKJ')" :class="{'form-group': true, 'has-error': errors.has('email_pkj')}">
        <label class="col-md-3"><span class="required-label">*</span>Email Pekerjaan</label>
        <div class="col-md-6">
          <input
            type="text"
            name="email_pkj"
            placeholder="Email Pekerjaan"
            class="form-control"
            maxlength="100"
            v-model="modelPkj.email"
            v-validate="isExist('EMAIL_PKJ') ? 'required|email' : 'email'"
          >
          <span v-show="errors.has('email_pkj')" class="error-label">Isi Email Pekerjaan dan dengan format email yang benar</span>
        </div>
      </div>
      <div v-show="isExist('FOTO')" class="form-group">
        <label class="col-md-3"><span class="required-label">*</span>Pas Foto (Sopan/Rapi)</label>
        <div class="col-md-6">
          <croppa
            v-model="foto"
            :width="300"
            :height="400"
            placeholder="FOTO">
          </croppa>
          <div>
            <div v-if="!modelFile.foto" style="margin-top: 20px" class="alert alert-success">Tekan area gambar untuk memilih foto. Scroll pada gambar untuk melakukan zoom in / zoom out. tekan dan tahan pada gambar untuk menggeser. Tekan tombol 'Upload' untuk mengupload atau mengupdate foto</div>
            <div v-if="modelFile.foto" style="margin-top: 20px" class="alert alert-success">Foto berhasil disimpan. <a :href="modelFile.foto" target="_blank">Cek Foto</a></div>
            <button class="btn btn-default" @click="sendPhoto">Upload Foto</button>
          </div>
          <pulse-loader style="margin: 15px" :loading="fotoUploading" color="#696969" size="5px"></pulse-loader>
          <span v-show="errors.has('foto')" class="error-label">Upload Foto</span>
        </div>
      </div>
      <div v-show="isExist('WNA')" class="form-group">
        <label class="col-md-3">Sertifikat WNA</label>
        <div class="col-md-6">
          <el-upload
            :action="docEndPointSertifikatWna"
            name="sertifikat_wna"
            :headers="header"
            :data="dataUpload"
            :on-error="handleError"
            :on-success="handleSertifikatSuccess"
            :before-upload="beforeDocsUpload"
            :limit="1"
            :on-exceed="handleExceed"
            :file-list="modelFile.sertifikat_wna"
            drag>
            <i class="el-icon-upload"></i>
            <div class="el-upload__text">Drop file here or <em>click to upload</em></div>
            <div class="el-upload__tip" slot="tip"><strong>format file dalam pdf / jpg / png dan tidak boleh lebih dari 1 Mb</strong></div>
          </el-upload>
          <div v-if="sertifikatWnaUrl" style="margin-top: 20px" class="alert alert-success">File berhasil disimpan. <a :href="sertifikatWnaUrl" target="_blank">Cek Dokumen</a></div>
        </div>
      </div>
    </form>
    <center>
      <pulse-loader style="margin: 15px" :loading="sending" color="#696969" size="10px"></pulse-loader>
    </center>
  </div>
</template>

<script>
import api from '@/api'
import { baseURL } from '@/api/data'
import Options from '@/helper/options'
import provinsi from '@/helper/data-master/provinsi'
import kabupaten from '@/helper/data-master/kabupaten'
import kecamatan from '@/helper/data-master/kecamatan'

export default {
  data () {
    return {
      init: false,
      loading: true,
      loadingKabupatenLahir: false,
      loadingKabupatenAsal: false,
      loadingKecamatanAsal: false,
      loadingKabupatenIni: false,
      loadingKecamatanIni: false,
      loadingKabupatenPkj: false,
      loadingKecamatanPkj: false,
      sending: false,
      fotoUploading: false,
      checkboxKTP: false,
      sertifikatWnaUrl: '',
      foto: {},
      model: {
        nama_lengkap: null,
        gelar_depan: null,
        gelar_belakang: null,
        gelar_depan_na: null,
        gelar_belakang_na: null,
        alamat_lengkap: null,
        tempat_lahir: null,
        tgl_lahir: null,
        telp: null,
        nohp: null,
        id_agama: null,
        jenis_kelamin: null,
        gol_darah: null,
        kabupaten_lahir: null,
        no_ktp: null,
        kode_provinsi: null,
        kode_kabupaten: null,
        kode_kecamatan: null,
        kelurahan: null,
        rt: null,
        rw: null,
        kode_pos: null,
        warga_negara: null,
        negara_asal: null,
        tinggi_badan: null,
        berat_badan: null,
        tanggal_akhir_ktp: null,
        alamat_asal: null,
        rt_asal: null,
        rw_asal: null,
        kode_provinsi_asal: null,
        kode_kabupaten_asal: null,
        kode_kecamatan_asal: null,
        kelurahan_asal: null,
        kode_pos_asal: null,
        website: null,
        email: null,
        facebook: null,
        twitter: null,
        blog: null
      },
      modelPkj: {
        nama_pekerjaan: null,
        alamat: null,
        rt: null,
        rw: null,
        kode_provinsi: null,
        kode_kabupaten: null,
        kode_kecamatan: null,
        kelurahan: null,
        kode_pos: null,
        telp: null,
        fax: null,
        email: null
      },
      savedModel: null,
      savedModelPkj: null,
      modelFile: {
        foto: '',
        sertifikat_wna: [],
        akta_kelahiran: []
      },
      options: {
        negara: [],
        provinsi: [],
        kabupaten: [],
        kabupatenLahir: [],
        kabupatenAsal: [],
        kecamatanAsal: [],
        kabupatenSaatIni: [],
        kecamatanSaatIni: [],
        kabupatenPkj: [],
        kecamatanPkj: [],
        agama: []
      }
    }
  },
  created () {
    this.initData()
  },
  updated () {
    this.$nextTick(function () {
      var elements = document.getElementsByClassName('el-upload__input')
      while (elements.length > 0) {
        elements[0].parentNode.removeChild(elements[0])
      }
    })
  },
  computed: {
    header () {
      let token = localStorage.getItem('client-admisi-token')
      let headerAPI = {
        'Authorization': `Bearer ${token}`
      }
      return headerAPI
    },
    dataUpload () {
      let data = {nomor_pendaftar: this.nomorPendaftar}
      return data
    },
    nomorPendaftar () {
      return this.$store.getters.getAuthData.data.mhs_jalur.nomor_pendaftar
    },
    docEndPointSertifikatWna () {
      if (process.env.NODE_ENV !== 'test') {
        return baseURL + 'v2/data_diri_pendaftar/sertifikat_wna'
      } else {
        return 'test'
      }
    },
    messages () {
      let message = ''
      this.$store.getters.getMessages(2).forEach(item => {
        message = message + ' ' + item.note + '.'
      })
      return message
    }
  },
  methods: {
    validate () {
      return new Promise((resolve, reject) => {
        this.validateForm()
          .then(valid => {
            this.sendDataDiri()
              .then(response => {
                if (this.isExist('NAMA_PKJ')) {
                  this.sendDataPekerjaan()
                    .then(response => {
                      resolve(true)
                    })
                    .catch(e => {
                      e.data ? this.flash(e.data.message, 'error') : this.flash('maaf terjadi kesalahan', 'error')
                      scroll(0, 0)
                      resolve(false)
                    })
                } else {
                  resolve(true)
                }
              })
              .catch(e => {
                e.data ? this.flash(e.data.message, 'error') : this.flash('maaf terjadi kesalahan', 'error')
                scroll(0, 0)
                resolve(false)
              })
          })
          .catch(e => {
            this.flash(e.message, 'error')
            scroll(0, 0)
            resolve(false)
          })
      })
    },
    validateForm () {
      return new Promise((resolve, reject) => {
        this.$validator.validateAll()
          .then(valid => {
            if (valid) {
              this.isExist('FOTO') && this.modelFile.foto === '' ? reject({message: 'belum ada foto'}) : false
              resolve(true)
            } else {
              reject({message: 'isian belum lengkap'})
            }
          })
      })
    },
    async initData () {
      if (!this.init) {
        try {
          this.loading = true
          this.options.provinsi = await provinsi.get()
          this.options.negara = await Options.getOptionsNegara()
          this.options.agama = await Options.getOptionsAgama()
          this.loading = false
        } catch (e) {
          this.loading = false
        }
        this.getDataDiri()
        this.getFoto()
        this.isExist('WNA') ? this.getSertifikatWna() : false
        this.isExist('NAMA_PKJ') ? this.getDataPekerjaan() : false
        this.init = true
        // this.isExist('AKTA') ? this.getAktaKelahiran() : false
      }
    },
    isExist (name) {
      return this.$store.getters.formIsExist(name, 2)
    },
    onChangeCheckBox () {
      if (this.checkboxKTP) {
        this.model.kelurahan = this.model.kelurahan_asal
        this.model.kode_provinsi = this.model.kode_provinsi_asal
        this.model.kode_kabupaten = this.model.kode_kabupaten_asal
        this.model.kode_kecamatan = this.model.kode_kecamatan_asal
        this.model.alamat_lengkap = this.model.alamat_asal
        this.model.rw = this.model.rw_asal
        this.model.rt = this.model.rt_asal
        this.model.kode_pos = this.model.kode_pos_asal
      } else {
        this.model.kelurahan = null
        this.model.kode_provinsi = null
        this.model.kode_kabupaten = null
        this.model.kode_kecamatan = null
        this.model.alamat_lengkap = null
        this.model.rw = null
        this.model.rt = null
        this.kode_pos = null
      }
    },
    updateTglLahir (date) {
      this.model.tgl_lahir = date
    },
    updateTglAkhirKtp (date) {
      this.model.tanggal_akhir_ktp = date
    },
    handleError (err, file, fileList) {
      if (process.env.NODE_ENV !== 'test') {
        let res = JSON.parse(err.message)
        alert(`upload error, ${res.message}`)
      } else {
        this.model.sertifikat_wna = [{name: 'sertifikat_wna_' + this.nomorPendaftar + '.pdf'}]
        this.sertifikatWnaUrl = 'test'
      }
    },
    handleExceed () {
      alert('maksimal 1 file')
    },
    handleAktaSuccess (res, file) {
      this.getAktaKelahiran()
      alert('upload sukses')
    },
    handleSertifikatSuccess (res, file) {
      this.getSertifikatWna()
      alert('upload sukses')
    },
    beforeDocsUpload (file) {
      const isMIME = file.type === 'application/pdf' || file.type === 'image/png' || file.type === 'image/jpeg'
      const isLt2M = file.size < 1000000
      !isMIME ? alert('Dokumen berformat pdf/jpg/png') : false
      !isLt2M ? alert('Dokumen tidak boleh lebih dari 1 Mb') : false
      return isMIME && isLt2M
    },
    getDataDiri () {
      this.loading = true
      api.get('/v1/data_diri_pendaftar/' + this.nomorPendaftar)
        .then(response => {
          let data = response.data.data
          this.model = data
          this.model.kode_provinsi_asal &&
            this.model.kode_provinsi_asal !== 0 &&
            this.model.kode_provinsi_asal !== '0' ? this.onChangeProvinsiAsal(false)
            : this.model.kode_provinsi_asal = null
          this.model.tempat_lahir &&
            this.model.tempat_lahir !== 0 &&
            this.model.tempat_lahir !== '0' ? this.onChangeProvinsiLahir(false)
            : this.model.tempat_lahir = null
          this.model.kode_provinsi &&
            this.model.kode_provinsi !== 0 &&
            this.model.kode_provinsi !== '0' ? this.onChangeProvinsiSaatIni(false)
            : this.model.kode_provinsi = null
          this.model.kode_kabupaten_asal &&
            this.model.kode_kabupaten_asal !== 0 &&
            this.model.kode_kabupaten_asal !== '0' ? this.onChangeKabupatenAsal(false)
            : this.model.kode_kabupaten_asal = null
          this.model.kode_kabupaten &&
            this.model.kode_kabupaten !== 0 &&
            this.model.kode_kabupaten !== '0' ? this.onChangeKabupatenIni(false)
            : this.model.kode_kabupaten = null
          this.loading = false
        })
        .catch(e => {
          this.loading = false
        })
    },
    getFoto () {
      api.get('/v2/data_diri_pendaftar/foto/' + this.nomorPendaftar)
        .then(response => {
          let responseData = response.data
          if (responseData.success) {
            this.modelFile.foto = responseData.url
          }
        })
    },
    getSertifikatWna () {
      api.get('/v2/data_diri_pendaftar/sertifikat_wna/' + this.nomorPendaftar)
        .then(response => {
          let responseData = response.data
          if (responseData.success) {
            this.model.sertifikat_wna = [{name: 'sertifikat_wna_' + this.nomorPendaftar + '.pdf'}]
            this.sertifikatWnaUrl = responseData.url
          }
        })
    },
    getDataPekerjaan () {
      api.get('/v1/pekerjaan_mahasiswa/' + this.nomorPendaftar)
        .then(response => {
          let responseData = response.data
          if (responseData.success) {
            let data = responseData.data
            this.modelPkj = data
            this.modelPkj.kode_provinsi ? this.onChangeProvinsiPkj(false) : false
            this.modelPkj.kode_kabupaten ? this.onChangeKabupatenPkj(false) : false
          }
        })
    },
    getAktaKelahiran () {
      api.get('/v2/data_diri_pendaftar/akta/' + this.nomorPendaftar)
        .then(response => {
          let responseData = response.data
          if (responseData.success) {
            this.model.akta_kelahiran = [{name: 'akta_' + this.nomorPendaftar + '.pdf'}]
          }
        })
    },
    sendDataDiri () {
      return new Promise((resolve, reject) => {
        this.sending = true
        if (process.env.NODE_ENV !== 'test') {
          const model = JSON.stringify(this.model)
          if (model !== this.savedModel) {
            api.post('/v2/data_diri_pendaftar', {
              nomor_pendaftar: this.nomorPendaftar,
              ...this.model
            })
              .then(response => {
                this.sending = false
                this.savedModel = model
                resolve(response.data)
              })
          } else {
            this.sending = false
            resolve(true)
          }
        } else {
          this.sending = false
          resolve(true)
        }
      })
    },
    sendDataPekerjaan () {
      return new Promise((resolve, reject) => {
        if (process.env.NODE_ENV !== 'test') {
          const modelPkj = JSON.stringify(this.modelPkj)
          if (modelPkj !== this.savedModelPkj) {
            api.post('/v2/pekerjaan_mahasiswa', {
              nomor_pendaftar: this.nomorPendaftar,
              ...this.modelPkj
            })
              .then(response => {
                this.savedModelPkj = modelPkj
                resolve(response.data)
              })
              .catch(e => {
                reject(e.response)
              })
          } else {
            resolve(true)
          }
        } else {
          resolve(true)
        }
      })
    },
    sendPhoto () {
      if (!this.foto.hasImage()) {
        alert('Anda belum memilih gambar')
        return
      }

      this.foto.generateBlob((blob) => {
        var fd = new FormData()
        fd.append('foto', blob, 'foto.png')
        fd.append('nomor_pendaftar', this.nomorPendaftar)

        this.fotoUploading = true
        if (process.env.NODE_ENV !== 'test') {
          api.post('/v2/data_diri_pendaftar/foto', fd)
            .then(response => {
              let responseData = response.data
              if (responseData.success) {
                alert('upload sukses')
                this.getFoto()
                this.fotoUploading = false
              }
            })
            .catch(e => {
              alert(e.response.data.message)
              this.fotoUploading = false
            })
        } else {
          alert('upload sukses')
          this.modelFile.foto = 'test'
          this.fotoUploading = false
        }
      })
    },
    async onChangeProvinsiLahir (makenull) {
      this.loadingKabupatenLahir = true
      try {
        this.options.kabupatenLahir = await kabupaten.getByProvinsi(this.model.tempat_lahir)
        makenull ? this.model.kabupaten_lahir = null : false
        this.loadingKabupatenLahir = false
      } catch (e) {
        this.loadingKabupatenLahir = false
        e.data ? this.flash(e.data.message, 'error') : this.flash('maaf terjadi kesalahan saat mengambil data kabupaten lahir', 'error')
        scroll(0, 0)
      }
    },
    async onChangeProvinsiAsal (makenull) {
      this.loadingKabupatenAsal = true
      try {
        this.options.kabupatenAsal = await kabupaten.getByProvinsi(this.model.kode_provinsi_asal)
        if (makenull) {
          this.model.kode_kabupaten_asal = null
          this.model.kode_kecamatan_asal = null
        }
        this.loadingKabupatenAsal = false
      } catch (e) {
        this.loadingKabupatenAsal = false
        e.data ? this.flash(e.data.message, 'error') : this.flash('maaf terjadi kesalahan saat mengambil data kabupaten asal', 'error')
        scroll(0, 0)
      }
    },
    async onChangeProvinsiSaatIni (makenull) {
      this.loadingKabupatenIni = true
      try {
        this.options.kabupatenSaatIni = await kabupaten.getByProvinsi(this.model.kode_provinsi)
        if (makenull) {
          this.model.kode_kabupaten = null
          this.model.kode_kecamatan = null
        }
        this.loadingKabupatenIni = false
      } catch (e) {
        this.loadingKabupatenIni = false
        e.data ? this.flash(e.data.message, 'error') : this.flash('maaf terjadi kesalahan saat mengambil data kabupaten saat ini', 'error')
        scroll(0, 0)
      }
    },
    async onChangeProvinsiPkj (makenull) {
      this.loadingKabupatenPkj = true
      try {
        this.options.kabupatenPkj = await kabupaten.getByProvinsi(this.modelPkj.kode_provinsi)
        if (makenull) {
          this.modelPkj.kode_kabupaten = null
          this.modelPkj.kode_kecamatan = null
        }
        this.loadingKabupatenPkj = false
      } catch (e) {
        e.data ? this.flash(e.data.message, 'error') : this.flash('maaf terjadi kesalahan saat mengambil data kabupaten pekerjaan', 'error')
        scroll(0, 0)
        this.loadingKabupatenPkj = false
      }
    },
    async onChangeKabupatenAsal (makenull) {
      this.loadingKecamatanAsal = true
      try {
        this.options.kecamatanAsal = await kecamatan.getByKabupaten(this.model.kode_kabupaten_asal)
        makenull ? this.model.kode_kecamatan_asal = null : false
        this.loadingKecamatanAsal = false
      } catch (e) {
        this.loadingKecamatanAsal = false
        e.data ? this.flash(e.data.message, 'error') : this.flash('maaf terjadi kesalahan saat mengambil data kecamatan asal', 'error')
        scroll(0, 0)
      }
    },
    async onChangeKabupatenIni (makenull) {
      this.loadingKecamatanIni = true
      try {
        this.options.kecamatanSaatIni = await kecamatan.getByKabupaten(this.model.kode_kabupaten)
        makenull ? this.model.kode_kecamatan = null : false
        this.loadingKecamatanIni = false
      } catch (e) {
        this.loadingKecamatanIni = false
        e.data ? this.flash(e.data.message, 'error') : this.flash('maaf terjadi kesalahan saat mengambil data kecamatan saat ini', 'error')
        scroll(0, 0)
      }
    },
    async onChangeKabupatenPkj (makenull) {
      this.loadingKabupatenPkj = true
      try {
        this.options.kecamatanPkj = await kecamatan.getByKabupaten(this.modelPkj.kode_kabupaten)
        if (makenull) {
          this.modelPkj.kode_kecamatan = null
        }
        this.loadingKabupatenPkj = false
      } catch (e) {
        e.data ? this.flash(e.data.message, 'error') : this.flash('maaf terjadi kesalahan saat mengambil data kecamatan pekerjaan', 'error')
        scroll(0, 0)
        this.loadingKabupatenPkj = false
      }
    }
  }
}
</script>

<style>
  .avatar-uploader .el-upload {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
  }

  .avatar-uploader .el-upload:hover {
    border-color: #409EFF;
  }

  .avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 178px;
    height: 237px;
    line-height: 237px;
    text-align: center;
  }

  .avatar {
    width: 178px;
    height: 237px;
    display: block;
  }
</style>



// WEBPACK FOOTER //
// src/page/register/DataDiri.vue